import { render, staticRenderFns } from "./DashboardTenant.vue?vue&type=template&id=69949697"
import script from "./DashboardTenant.vue?vue&type=script&lang=js"
export * from "./DashboardTenant.vue?vue&type=script&lang=js"
import style0 from "./DashboardTenant.vue?vue&type=style&index=0&id=69949697&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports